import { tv } from 'tailwind-variants';

const aiResponseStyles = tv({
    slots: {
        container: `
      iris:flex
      iris:w-full
      iris:flex-col
      iris:gap-(--base-space-px-16)
    `,
        contentItem: `
      iris:w-full
    `,
    },
    variants: {
        inverse: {
            false: "",
            true: "",
        },
    },
    defaultVariants: {
        inverse: false,
    },
});

export { aiResponseStyles };
